export default __webpack_public_path__ + "static/media/burkina-faso.680b236e.png";